// Header.jsx
import { useState, useEffect } from 'react';
import { motion, LayoutGroup } from 'framer-motion';
import ContactModal from './ContactModal';

const navItems = [
  { id: 'home', label: 'Home' },
  { id: 'services', label: 'Servizi' },
  { id: 'solutions', label: 'Soluzioni' },
  { id: 'approach', label: 'Come operiamo' },
  { id: 'about', label: 'Chi siamo' }
];

export default function Header() {
  const [active, setActive] = useState('home');
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    const handleResize = () => { if (window.innerWidth > 768) setMenuOpen(false); };
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const ids = navItems.map(item => item.id);
    const observers = [];

    ids.forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActive(id); },
        { threshold: 0, rootMargin: '-40% 0px -55% 0px' }
      );
      obs.observe(el);
      observers.push(obs);
    });

    return () => observers.forEach(obs => obs.disconnect());
  }, []);

  const scrollTo = id => {
    setActive(id);
    setMenuOpen(false); // chiudi il menu dopo la selezione
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <>
      <header className="header">
        <div className={`header-inner ${isScrolled ? 'scrolled' : ''} ${menuOpen ? 'mobile-open' : ''}`}>
          <img src="/assets/logo.png" alt="Logo" className="header-logo" />

          {/* Burger (visibile solo su mobile via CSS) */}
          <button
            className={`header-burger ${menuOpen ? 'is-open' : ''}`}
            aria-label="Apri menu"
            aria-expanded={menuOpen}
            aria-controls="mobile-menu"
            onClick={() => setMenuOpen(o => !o)}
          >
            <span></span><span></span><span></span>
          </button>

          <LayoutGroup id="header-nav">
            <nav className="header-nav" id="mobile-menu" role="navigation">
              <ul>
                {navItems.map(({ id, label }) => (
                  <li key={id} className="nav-item">
                    <button
                      onClick={() => scrollTo(id)}
                      className={`nav-link ${active === id ? 'is-active' : ''}`}
                    >
                      {label}
                      {isScrolled && active === id && (
                        <motion.span
                          layoutId="pill"
                          className="pill"
                          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                        />
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </LayoutGroup>

          {/* CTA che diventa floating su mobile */}
          <button onClick={handleContactClick} className="header-contact-cta">
            Contattaci
          </button>
        </div>
      </header>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
